/* Browser Window */
.browser {
  position: absolute;
  background: var(--color-surface);
  border: var(--border-medium) var(--border-style) var(--color-border-strong);
  border-radius: var(--radius-window);
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  will-change: transform;
  display: flex;
  flex-direction: column;
  animation: windowOpen 0.3s ease-out;
  transform-origin: center center;
}

.browser.dragging {
  cursor: grabbing;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.25);
}

.browser.maximized {
  border-radius: 0;
}

@keyframes windowOpen {
  from {
    opacity: 0;
    scale: 0.95;
  }
  to {
    opacity: 1;
    scale: 1;
  }
}

.browser.closing {
  animation: windowClose 0.2s ease-in forwards;
  pointer-events: none;
}

@keyframes windowClose {
  from {
    opacity: 1;
    scale: 1;
  }
  to {
    opacity: 0;
    scale: 0.95;
  }
}

.browserHeader {
  background: var(--color-surface-raised);
  border-bottom: var(--border-thin) var(--border-style) var(--color-border);
  padding: 0 var(--space-3);
  display: flex;
  align-items: stretch;
  gap: var(--space-3);
  cursor: grab;
  user-select: none;
  touch-action: none;
}

.browser.dragging .browserHeader {
  cursor: grabbing;
}

.browserTabs {
  display: flex;
  gap: var(--space-0-5);
  flex: 1;
  overflow: hidden;
  align-self: flex-end;
  align-items: flex-end;
  padding-top: var(--space-2);
}

.browserTab {
  --tab-width: 140px;

  display: flex;
  align-items: center;
  gap: var(--space-1-5);
  padding: var(--space-1-5) var(--space-3);
  max-width: var(--tab-width);
  min-width: 0;
  flex: 1 1 var(--tab-width);
  background: var(--color-surface-sunken);
  border: var(--border-thin) var(--border-style) var(--color-border);
  border-bottom: none;
  border-radius: var(--radius-xs) var(--radius-xs) 0 0;
  font-family: var(--font-sans);
  font-size: var(--text-sm);
  font-weight: var(--font-normal);
  color: var(--color-text-muted);
  cursor: pointer;
  transition: background var(--transition-fast), color var(--transition-fast);
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: -1px;
}

.browserTab:hover {
  background: var(--color-surface);
  color: var(--color-text);
}

.browserTab.active {
  background: var(--color-surface);
  color: var(--color-text);
  font-weight: var(--font-medium);
  border-color: var(--color-border);
  border-bottom: var(--border-thin) var(--border-style) var(--color-surface);
}

.tabFavicon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: var(--color-accent-primary);
  flex-shrink: 0;
}

.tabFavicon svg {
  width: 100%;
  height: 100%;
}

.tabLabel {
  overflow: hidden;
  text-overflow: ellipsis;
}

.browserAddressBar {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2-5) var(--space-3);
  background: var(--color-surface-sunken);
  border-bottom: var(--border-thin) var(--border-style) var(--color-border);
  font-family: var(--font-mono);
  font-size: var(--text-sm);
}

.addressIcon {
  display: flex;
  align-items: center;
  color: var(--color-success);
}

.addressIcon svg {
  width: 14px;
  height: 14px;
}

.addressUrl {
  color: var(--color-text);
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.addressUrl:hover {
  text-decoration: underline;
}

.browserBody {
  flex: 1;
  overflow: auto;
}
